import { useRouter } from 'next/router'
import React from 'react'
import useScrollPosition from '@react-hook/window-scroll'
import BlockText from '../content/BlockText'
import BlockReviews from './BlockReviews'
import BlockMap from './BlockMap'
import BlockList from '../content/BlockList'
import BlockSuburbs from './BlockSuburbs'
// import BlockOpeningHours from './BlockOpeningHours'
const BlockOpeningHours = dynamic(() => import('./BlockOpeningHours'), {
  ssr: false,
})
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import JSONSchema from './JSONSchema'
import Head from 'next/head'
import { NavBar, Toggler } from '../layout/NavBar'
import NavBarAddress from '../clinic/NavBarAddress'
import SuburbJumbotron from './SuburbJumbotron'
import Container from '@bootstrap-styled/v4/lib/Container'
import Row from '@bootstrap-styled/v4/lib/Row'
import Col from '@bootstrap-styled/v4/lib/Col'
import Footer from '../layout/Footer'
import Button from '../Button'
import styled from 'styled-components'
import Img from '@bootstrap-styled/v4/lib/Img'
import { PageBody, BookButton, NavBarButton } from '../pages/Location'
import BlockPhysios from './BlockPhysios'
import { Dl, Dt, Dd } from '../content'
import dynamic from 'next/dynamic'
import Hr from '@bootstrap-styled/v4/lib/Hr'
import { useBooking } from '../booking/BookingFormProvider'
import BottomBar from '../BottomBar'
const BookingModal = dynamic(() => import('../booking/BookingModal'), {
  ssr: false,
})

const Break = styled.div`
  flex-basis: 100%;
  height: 0;
`

const RatingImg = styled(Img)`
  height: 60px;
  border-radius: 4px;
  margin-right: 12px;
  @media (max-width:720px) {
    display: none;
    margin-bottom: 12px;
  }
`

const src2 = require('../../assets/images/google-rating.png')

function SuburbPage ({ suburb, clinic, reviewData, nextEvents = [], popularStreets = [] }) {
  const { name: suburbTitle } = suburb
  const router = useRouter()

  // const [isOpen, setOpen] = React.useState(false)
  const [modalState, setModalState] = React.useState(false)
  const [modalLoader, setModalLoader] = React.useState(false)

  const { setClinic, setSuburb } = useBooking()

  React.useEffect(() => {
    setSuburb(suburb)
    if (clinic && clinic.provider) setClinic(clinic)
    else setClinic({
      id: suburb.id,
      name: suburb.name,
      provider: 'typeform',
      providerData: {
        name: suburb.name,
        state: suburb.state,
        postcode: suburb.postcode,
      }
    })
  }, [clinic, suburb])

  React.useEffect(() => {
    setModalState(router.query.booking === 'true')
  }, [])
  React.useEffect(() => {
    if (modalState && !router.query.booking) {
      router.push(
        {

          pathname: router.pathname,
          query: { booking: 'true' }
        },
        {

          pathname: `/physiotherapy/${suburb.id}`,
          query: { booking: 'true' }
        },
        { shallow: true }
      )
    } else if (!modalState && router.query.booking) {

      router.push(
        {
          pathname: router.pathname,
        },
        {
          pathname: `/physiotherapy/${suburb.id}`,
        },
        { shallow: true }
      )
    }
  }, [modalState, router])

  const contentRef = React.useRef(null)
  const [scrolledDown, setScrolledDown] = React.useState(false)

  const [showBottomBar, setShowBottomBar] = React.useState(false)
  const [bottomBarContent, setBottomBarContent] = React.useState(null)

  if (typeof window !== 'undefined') {
    const scrollY = useScrollPosition(1)
    React.useEffect(() => {
      if (contentRef.current === null) return
      const { y } = contentRef.current.getBoundingClientRect()
      setScrolledDown(y < 50)
      setShowBottomBar(y < 350)
    }, [ scrollY, contentRef ])
  }

  const toggleModal = (force = false) => {
    if (force === true || modalLoader === true) {
      setModalLoader(false)
      setModalState(false)
    } else {
      setModalLoader(true)
      setTimeout(() => {
        setModalState(true)
      }, 50)
    }
  }

  // const suburbsNearby = chunk(nearby.slice(0, 12), 4)
  // const popularStreets = chunk(streets.slice(0, 12), 4)

  const onCallToAction = () => {
    if (typeof window !== 'undefined' && typeof gtag !== 'undefined') {
      gtag('event','click',{
        event_category: 'Booking',
        event_action: 'open',
      });
    }
    toggleModal()
    // if (clinic && clinic.provider) toggleModal()
    // else {
      // window.location.href = `https://localphysionetwork.typeform.com/to/O71lmbIO#suburb=${suburb.name}&state=${suburb.state}&postcode=${suburb.postcode}`
    // }
  }

  const loader = (modalLoader && !modalState) && <FontAwesomeIcon icon={faSpinner} spin/>

  return (
    <PageBody>
      { clinic && <JSONSchema
        clinic={clinic}
        suburb={suburb}
        nearbySuburbs={suburb.nearbySuburbs || []}
        nextEvents={nextEvents}
        reviewData={reviewData}
      /> }
      <Head>
        <title>{suburbTitle} Physiotherapy clinic / Physio / Physiotherapist</title>
        <meta name={'description'} content={suburb.seo.description}/>
        <link rel={'canonical'} href={`${process.env.REACT_APP_APP_URL}/physiotherapy/${suburb.id}`}/>
      </Head>

      <NavBar title={`Local Physio ${suburbTitle}`} fixed={'true'}>
        { (clinic && clinic.address) && <NavBarAddress className={'d-none d-lg-flex'} clinic={clinic}/>}
        <NavBarButton
          outline={!scrolledDown}
          size={'lg'}
          color={'primary'}
          className={'d-none d-lg-block'}
          role="button"
          disabled={modalState}
          onClick={onCallToAction}>
          Book an appointment {loader}
        </NavBarButton>
        {/*{ (isOpen) && <React.Fragment>*/}
        {/*  <NavBarButton*/}
        {/*    outline={!scrolledDown}*/}
        {/*    size={'lg'}*/}
        {/*    color={'primary'}*/}
        {/*    className={'d-block d-lg-none'}*/}
        {/*    role="button"*/}
        {/*    disabled={modalState}*/}
        {/*    onClick={onCallToAction}>*/}
        {/*    Book an appointment {loader}*/}
        {/*  </NavBarButton>*/}
        {/*  <Break className={'d-block d-md-none'}/>*/}
        {/*</React.Fragment> }*/}
      </NavBar>

      <SuburbJumbotron suburb={suburb} clinic={clinic}>
        <RatingImg src={src2} alt={'Google rating'}/>
        <BookButton
          id={`booking-modal-toggle`}
          color="primary"
          size="lg"
          role="button"
          disabled={modalState}
          onClick={onCallToAction}>Book an appointment<span className={'d-none d-lg-inline'}> online</span> {loader}
        </BookButton>
      </SuburbJumbotron>

      <div ref={contentRef}>
        <Container>
          <Row>
            <Col lg={8} xs={12}>
              { (clinic && (clinic.profile || clinic.additionalContent)) && <BlockText title={`About ${clinic.name}`} value={clinic.profile}>
                { clinic.additionalContent && (<React.Fragment>
                  {
                    clinic.additionalContent.tagline &&
                    <BlockText
                      title={`Clinic tag-line / mission statement`}
                      value={clinic.additionalContent.tagline}
                      titleLevel={4}
                      contentLevel={'article'}
                    />
                  }
                  {
                    clinic.additionalContent.unique &&
                    <BlockText
                      title={`What makes ${clinic.name} unique`}
                      value={clinic.additionalContent.unique}
                      titleLevel={4}
                      contentLevel={'article'}
                    />
                  }
                  {
                    clinic.additionalContent.specialize &&
                    <BlockText
                      title={`We specialise in some of the following`}
                      value={clinic.additionalContent.specialize}
                      titleLevel={4}
                      contentLevel={'article'}
                    />
                  }
                </React.Fragment>)
                }
              </BlockText> }
              {
                (clinic && clinic.practitioners && clinic.practitioners.length > 0) &&
                <BlockPhysios
                  title={'Our practitioners'}
                  practitioners={clinic.practitioners}
                  image={clinic.practitionersImage}
                  suburbName={suburb.name}
                />
              }
              <BlockMap
                title={'Our location'}
                value={suburb.locationGuide}
                suburbId={suburb.id}
                location={clinic ? clinic.location : null}
              >
                { suburb.locationInfo && <BlockText titleLevel={4} contentLevel={'article'} value={suburb.locationInfo}/> }
                {clinic && (<React.Fragment>
                  <Hr/>
                  <Dl className={'row'}>
                    <Dt className={'col-4'}>Parking</Dt>
                    <Dd className={'col-8'}>{clinic.parking || 'N/A'}</Dd>
                    <Dt className={'col-4'}>Disability access</Dt>
                    <Dd className={'col-8'}>{clinic.disabilityAccess ? 'Yes' : 'No'}</Dd>
                  </Dl>
                </React.Fragment>)}
              </BlockMap>
              { clinic && <React.Fragment>
                { (clinic.openingHoursSpecification && clinic.openingHoursSpecification.length)
                && <BlockOpeningHours title={'Open hours'} clinic={clinic}/> }
                { (clinic.paymentAccepted) && <BlockText title={'Payment Methods Accepted'} titleLevel={4}>
                  { clinic.paymentAccepted.split(',').join(', ') }
                </BlockText>}
                { (clinic.preferredProviders) && <BlockText title={'Preferred provider arrangements'} titleLevel={4}>
                  { clinic.preferredProviders.split(',').join(', ') }
                </BlockText>}
              </React.Fragment>}
              {
                (suburb.nearbySuburbs &&
                suburb.nearbySuburbs.length > 0) &&
                <BlockSuburbs title={'Suburbs we service'} value={suburb.nearbySuburbs}/>
              }
              { suburb.services && <BlockList title={'Our physio services'} value={suburb.services} ticks/> }
              { suburb.treatments && <BlockList title={'What we treat'} value={suburb.treatments} ticks/> }
              { (reviewData.count > 0) && <BlockReviews title={'Ratings & Reviews'} reviewData={reviewData}/> }
              { (suburb.seo && suburb.seo.content) && suburb.seo.content.map((b, i) => (
                <BlockText key={`seo-block-${suburb.id}-${i}`} value={b.value} title={b.title}/>
              )) }
              { suburb.faq && <BlockText title={'General FAQs'} value={suburb.faq}/> }
              { suburb.profile && <BlockText title={`${suburbTitle} profile`} value={suburb.profile}/> }
              {
                (popularStreets && popularStreets.length > 0) &&
                <BlockList title={`Popular streets in ${suburbTitle}`} value={popularStreets} ticks={false}/>
              }
            </Col>
          </Row>
        </Container>
      </div>
      <Footer/>
      <BookingModal
        address={clinic && clinic.address}
        phone={clinic && clinic.phone}
        location={clinic && clinic.location}
        timezone={suburb.timezone || 'Australia/Sydney'}
        initialClinicId={clinic && clinic.id}
        isOpen={modalState}
        setBottomBarContent={setBottomBarContent}
        onClose={() => toggleModal(true)}
        // onComplete={toggleModal}
      />
      <BottomBar
        content={bottomBarContent}
        action={onCallToAction}
        show={modalState && showBottomBar}
      />
    </PageBody>
  )
}

export default SuburbPage
